import { render } from "./SearchProductsFull.vue?vue&type=template&id=03863bdd"
import script from "./SearchProductsFull.vue.ts?vue&type=script&lang=ts"
export * from "./SearchProductsFull.vue.ts?vue&type=script&lang=ts"
script.render = render

export default script